import React, { Component } from 'react';
import Alert from 'react-s-alert';
import classNames from 'classnames';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import { renderTextField } from '../../../../../../components/reduxFields';
import PaginatorCustom from '../../../../../../components/paginationCustom';
import SortingCustom from '../../../../../../components/SortingCustom';
import { Field, reduxForm, reset } from 'redux-form';
import { alertConfirmation, showFormatedDateandTime } from '../../../../../../actions/utilAction';
import { deleteRawABCData, getRawABCDataList } from './actions/rawABCDataActions';
import Tooltip from '../../../../../../components/Tooltip';


class RawABCData extends Component {
  constructor(props) {
    super(props);
    this.state = {      
        rawABCDataId: null,        
      patientId: props.patientId
    };

    this.filter = {
      sort_Column: '',
      sort_order: '',
      searchText: '',
    };
    
    this.renderRawABCData = this.renderRawABCData.bind(this);
    this.handleAlertClick = this.handleAlertClick.bind(this);    
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSubmitSearch = this.handleSubmitSearch.bind(this);
    this.handleResetButton = this.handleResetButton.bind(this);
  }

  componentWillMount() {
    this.loadData();
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.delete_rawABCData && nextProps.delete_rawABCData !== this.props.delete_rawABCData) {
      this.loadData();
    }
  }
  loadData(page_number) {
    let searchObj = {
      sort_fields: this.filter.sort_Column || '',
      sort_order: this.filter.sort_order || '',
      contain_filters: { searchText: this.filter.searchText || null, patientId: this.state.patientId || null },
      pageNumber: page_number ? page_number : 1,
    };
    this.props.getRawABCDataList(searchObj);
  }


  handleAlertClick = (event, Id) => {
    Alert.closeAll();
    this.props.deleteRawABCData(Id);
  };

  handleDeleteClick = (e, obj) => {
    let warningMsg = `Are you sure you want to delete this data?`;
    alertConfirmation(warningMsg, {
      html: true,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: obj.recordABCDataId,
      },
    });
  };

  setSortColumn(col_name, col_order) {
    this.filter.sort_Column = col_name;
    this.filter.sort_order = col_order;
    this.loadData();
  }

  componentWillUnmount() {
    Alert.closeAll();
  }

  handleSearchChange(event) {
    if (event.target.value.length > 2) {
      this.filter.searchText = event.target.value;
      this.loadData();
    } else if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadData();
    }
  }
  handleResetButton() {
    Alert.closeAll();
    this.props.dispatch(reset('RawABCDataForm'));    
    this.loadData();
  }

  handleSubmitSearch() {
    return false;
  }

  renderRawABCData = (RawABCDataList) => {
    RawABCDataList = RawABCDataList || [];

    if (!RawABCDataList.length) {
      return (
        <tr>
          <td colSpan="8">
            <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
          </td>
        </tr>
      );
    }
    return RawABCDataList.map((data, index) => {        
      return (
        <tr key={index}>
          <td>{showFormatedDateandTime(data.sessionTime)}</td>
          <td>
              {data.notes && data.notes.length > 0 ?
              <Tooltip Description={data.notes} />
              : null}
              {data.staffName}
          </td>     
          <td>{data.timeInterval}</td>     
          <td>{data.behaviors}</td>     
          <td>{data.consequences}</td>     
          <td>{data.antecedents}</td>     
          <td>{data.locations}</td>     
          {this.props.deletePermission ?
            <td>              
              {this.props.deletePermission ?
                <button onClick={(e) => this.handleDeleteClick(e, data)} title="Delete" type="button" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                : null}
            </td>
            : null}
        </tr>
      );
    });
  };

  render() {
    const { handleSubmit, rawABCDataListData } = this.props,
    RawABCDataList = (rawABCDataListData && rawABCDataListData.data) || [],
    RawABCDataMeta = (rawABCDataListData && rawABCDataListData.meta) || null;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.bordered,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
      'suptable': true,
    });
    return (
      <div>        
        <div className="row mt-3">     
        <div className="col-sm-6"></div>     
          <div className="col-sm-6">
            <div className="row end-flex">
              <div className="col-sm-8 mtm-27">
                <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSubmitSearch)}>
                  <Field
                    name="Name"
                    floatingLabelText="Search"
                    maxLength="10"
                    onChange={this.handleSearchChange}
                    component={renderTextField}
                    fullWidth={true}
                  />
                </form>
              </div>
              <div className="reset-btn col-sm-4">
                <RaisedButton className="grey_btn" onTouchTap={this.handleResetButton} >Reset</RaisedButton>
              </div>
            </div>
          </div>
        </div>

        <div className="table-responsive mt-15">
          <table className={tableClass}>
            <thead>
              <tr>
                <th width="15%">{<SortingCustom noSort={!RawABCDataList.length} setSortColumn={this.setSortColumn} columnName='sessionDate' displayName='Session Date' />}</th>
                <th width="16%">{<SortingCustom noSort={!RawABCDataList.length} setSortColumn={this.setSortColumn} columnName='staffName' displayName='Staff Name' />}</th>
                <th width="8%">Duration</th>
                <th width="14%">Behaviors</th>
                <th width="14%">Consequences</th>
                <th width="14%">Antecedents</th>
                <th width="14%">Locations</th>
                {this.props.deletePermission ?
                  <th width="5%">Actions</th>
                  : null
                }
              </tr>
            </thead>
            <tbody>
              {this.renderRawABCData(RawABCDataList)}
            </tbody>
          </table>
        </div>
        {RawABCDataMeta && RawABCDataMeta['totalPages'] ?
          <PaginatorCustom data={RawABCDataMeta} handlePageChange={(page_number) => this.loadData(page_number)} />
          : null
        }
      </div>
    );
  }
}

RawABCData = reduxForm({
  form: 'RawABCDataForm',
})(RawABCData);

function mapStateToProps(state) {

  // Start For Role Permission
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === "CLIENT");
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === "CLIENT_DATACOLLECTION_SETUP" && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_DELETE_RAWABCDATA")[0].permission : false;

  // End For Role Permission
  return {
    loading: state.patient_rawABCData.loading,
    rawABCDataListData: state.patient_rawABCData.rawABCDataList,
    delete_rawABCData: state.patient_rawABCData.delete_rawABCData,
    saved_rawABCData: state.patient_rawABCData.saved_rawABCData,
    deletePermission: deletePermission, // For Role Permission
  };
}

export default connect(mapStateToProps, { deleteRawABCData, getRawABCDataList })(RawABCData);



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/BehaviorReductiom/RawABCData/index.js